import { atom } from "jotai";
import { State } from "./State";
import { postBase } from "./BaseApi";

export type PostUserInvestmentTransactionParam = {
  pointOwnerId?: number;
  transactionType: "buy" | "sell";
  indexCode: string;
  units: number;
  tradeAmount: number;
  unitPrice: number;
};

const uri = "api/users/investment-transaction";

export const postUserInvestmentTransactionAtom = atom<State<void> | null>(null);

export const postUserInvestmentTransaction = () => {
  return postBase<void, PostUserInvestmentTransactionParam>(
    uri,
    postUserInvestmentTransactionAtom
  );
};
